import React from 'react';
import Grid from '@material-ui/core/Grid';
import {Styles} from '../../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../../../config/Translate";
import axios from "axios";
import {defaultVariabls} from "../../../../../config/index";
import {getStore, setStore} from "trim-redux";
import MaterialTable from "material-table";
import {tableIcons} from "../../../../../config/design/TableIcons";
import {withRouter} from 'react-router-dom';
import { withSnackbar } from 'notistack';
import {platforms, TableCount, TablePage,platformsWithName} from "../../../../../config/Permissions";
import moment from "jalali-moment";
import Container from "@material-ui/core/Container/Container";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import AppCardLoaderTable from "../../../../components/Skeletons/AppCardLoaderTable";
import withWidth from "@material-ui/core/withWidth/withWidth";
import TextField from "@material-ui/core/TextField/TextField";
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";
import LoadingButton from "../../../../components/elements/LoadingButton";
import UpdateRoundedIcon from '@material-ui/icons/UpdateRounded';
class SafeCoins extends React.Component {
    constructor(props) {
        super(props)
        this.tableRef = React.createRef()
    }
    classes = this.props.classes;
    type = this.props.match.params.type;
    state = {
        columns : [
            {
                title: Translate.currency_name,
                field: 'name',
                editable:'never',
            },
            { title: Translate.priceEqualToOneDollar,
                field: 'price',
            },
            { title: Translate.lastUpdate, field: 'lastUpdate',editable:"never"},
        ],
        data: [],
        loading:false,
        ChangeLoader:false,
        SubmitLoading:false
    };
    componentDidMount(){
        this.loadData();
    }

    loadData(){
        this.tableRef.current && this.tableRef.current.onQueryChange()
    }
    onEdit(currency) {
        let authUser = getStore().user;
        if(authUser.role.permission.manageSettings){
            let data = new FormData();
            data.append('id', !! currency.id ? currency.id : "");
            data.append('price', currency.price);
            let loginToken = localStorage.getItem('ACT');
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            axios.post(`${defaultVariabls.url}/currencies/update`, data, config)
                .then(response => {
                    this.props.enqueueSnackbar(Translate.detailsSet, {
                        variant: 'success',
                    });
                    this.loadData();
                    return true
                })
                .catch(error => {
                    console.log(error.response)
                    this.props.enqueueSnackbar(Translate.detailsSetFailed, {
                        variant: 'error',
                    });
                    return false
                });
        }else{
            this.props.enqueueSnackbar(Translate.youDontHavePermission, {
                variant: 'error',
            });
            this.loadData();
        }

    }
    async handleAutoLoad(){
        await this.setState({
            SubmitLoading:true
        })
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/currencies/auto-update`, config)
                .then(response => {
                    this.props.enqueueSnackbar(Translate.currenciesUpdated, {
                        variant: 'success',
                    });
                    this.loadData();
                    this.setState({
                        SubmitLoading:false
                    })

                }).catch(error => {
                    this.setState({
                        SubmitLoading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
        }
    }
    render(){
        let loginToken = localStorage.getItem('ACT');
        let {SubmitLoading} = this.state;
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        const data = new FormData();
        return (
            <>
                {
                    this.state.loading ? <AppCardLoaderTable/> :
                        <Container maxWidth="xl" className="safecoin-container">
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <MaterialTable
                                        parentChildData={(row, rows) => rows.find(a => a.id === row.parentId)}
                                        tableRef={this.tableRef}
                                        icons={tableIcons}
                                        title={
                                            <LoadingButton
                                                variant="contained"
                                                color="primary"
                                                size="small"
                                                startIcon={<UpdateRoundedIcon/>}
                                                onClick={this.handleAutoLoad.bind(this)}
                                                loading = {SubmitLoading}
                                            >
                                                {Translate.autoUpdateCurrencies}
                                            </LoadingButton>
                                        }
                                        columns={this.state.columns}
                                        data={query =>
                                            new Promise((resolve, reject) => {
                                                axios.post(`${defaultVariabls.url}/currencies/get?page=${query.page + 1}&per_page=${query.pageSize}&search=${query.search}`,data, config)
                                                    .then(response => {
                                                        let data = [];
                                                        // eslint-disable-next-line
                                                        response.data.map((row) => {
                                                            data.push({
                                                                price: row.price,
                                                                name: row.name,
                                                                id: row.id,
                                                                lastUpdate:`${moment(row.updated_at).fromNow()}`
                                                            })
                                                        });
                                                        resolve({
                                                            data: data,
                                                            page: response.data.current_page - 1,
                                                            totalCount: response.data.total,
                                                        })
                                                    }).catch(error => {
                                                    console.log(error)
                                                })
                                            })
                                        }
                                        options={{
                                            pageSize: TablePage,
                                            pageSizeOptions: TableCount,
                                        }}
                                        editable={{
                                            onRowUpdate: (newData, oldData) =>
                                                new Promise(resolve => {
                                                    setTimeout(() => {
                                                        resolve();
                                                        this.onEdit(newData);
                                                        if (oldData) {
                                                            this.setState(prevState => {
                                                                const data = [...prevState.data];
                                                                data[data.indexOf(oldData)] = newData;
                                                                return { ...prevState, data };
                                                            });
                                                        }
                                                    }, 600);
                                                }),
                                        }}

                                    />
                                </Grid>
                            </Grid>
                        </Container>
                }
            </>
        );
    }
}

export default  withWidth()(withSnackbar(withRouter(withStyles(Styles)(SafeCoins))));